import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { fontSizes, fontWeights } from "et3-ui-library";
import {
  KHATTABAT_AUTH_CARD_MAX_WIDTH,
  KHATTABAT_LOGIN_LOGO_WIDTH
} from "../../constants/core-constants";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";

const KhattabatLoginForm = withLiteObserverAndTheme(() => {
  const {
    username,
    password,
    errorKey,
    hasSignInError,
    signInLoading,
    isSignInDisabled,
    isPasswordVisible,
    setUserName,
    setPassword,
    togglePasswordVisible,
    submitSignIn,
    signInOnEnter
  } = getCoreLoginStore();
  const isDisabled = isSignInDisabled.get();
  const isLoading = signInLoading.get();
  const isVisible = isPasswordVisible.get();

  return (
    <Paper
      variant="outlined"
      sx={{
        width: 1,
        maxWidth: KHATTABAT_AUTH_CARD_MAX_WIDTH,
        boxSizing: "border-box",
        p: { xs: 3, sm: 4 },
        borderRadius: 3
      }}
    >
      <Stack spacing={1} alignItems="center" sx={{ mb: 3 }}>
        <Box
          component="img"
          src={require("../../assets/images/et3-logo.png")}
          alt={i18n.get("ALKHATTABA_ADMIN")}
          sx={{ width: KHATTABAT_LOGIN_LOGO_WIDTH, height: "auto" }}
        />
        <Typography variant="h6" fontWeight={fontWeights.bold}>
          {i18n.get("ALKHATTABA_ADMIN")}
        </Typography>
      </Stack>
      <Stack spacing={2.25}>
        {hasSignInError.get() ? (
          <Alert severity="error" variant="outlined">
            {i18n.get(errorKey.get())}
          </Alert>
        ) : null}
        <TextField
          label={i18n.get("USERNAME")}
          autoComplete="username"
          autoFocus
          fullWidth
          value={username.get()}
          onChange={(event) => setUserName(event.target.value)}
          onKeyDown={(event) => signInOnEnter(event.key)}
        />
        <TextField
          label={i18n.get("PASSWORD")}
          type={isVisible ? "text" : "password"}
          autoComplete="current-password"
          fullWidth
          value={password.get()}
          onChange={(event) => setPassword(event.target.value)}
          onKeyDown={(event) => signInOnEnter(event.key)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={i18n.get(
                      "KHATTABAT_TOGGLE_PASSWORD_VISIBILITY"
                    )}
                    onClick={togglePasswordVisible}
                    edge="end"
                  >
                    {isVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />
        <Button
          variant="contained"
          size="large"
          fullWidth
          disabled={isDisabled}
          startIcon={
            isLoading ? (
              <CircularProgress size={fontSizes.lg} color="inherit" />
            ) : null
          }
          onClick={submitSignIn}
        >
          {i18n.get("SIGN_IN")}
        </Button>
      </Stack>
    </Paper>
  );
});
export default KhattabatLoginForm;
